import React from "react";
import { Grid, TextField } from "@material-ui/core";
import styled from "styled-components";
import { RawLinkButton } from "../LinkButton";
import FormHelperText from "../forms/FormHelperText";

const FullWidthTextField = styled(TextField)`
  min-width: 475px;
  max-width: 600px;
`;

export interface ISupportTicketFormProps {
  submitButtonText: string;
  onFormSubmit: (summary: string, description: string) => Promise<boolean>;
  prefilledDescription?: string;
}

const SubmitSupportTicketForm = (props: ISupportTicketFormProps) => {
  const { onFormSubmit, submitButtonText, prefilledDescription } = props;
  const [summary, setSummary] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>(prefilledDescription || "");

  const reset = () => {
    setSummary("");
    setDescription("");
  };

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (await onFormSubmit(summary, description)) {
      reset();
    }
  };

  return (
    <>
      <Grid item container spacing={3}>
        <Grid item>
          <FullWidthTextField
            id="description"
            label={"Request Details"}
            variant="outlined"
            multiline={true}
            rows={4}
            rowsMax={100}
            required
            onChange={(evt: React.ChangeEvent<HTMLInputElement>) => setDescription(evt.target.value)}
            value={description}
          />
          <FormHelperText>What can we help you with? The more details, the better!</FormHelperText>
        </Grid>
        <Grid item>
          <FullWidthTextField
            id="summary"
            label="Summary"
            variant="outlined"
            required
            onChange={(evt: React.ChangeEvent<HTMLInputElement>) => setSummary(evt.target.value)}
            value={summary}
            inputProps={{ maxLength: 50 }}
          />
          <FormHelperText>Now, summarize the above in a few words, please!</FormHelperText>
        </Grid>
      </Grid>
      <Grid item>
        <RawLinkButton first onClick={handleSubmit}>
          <>{submitButtonText}</>
        </RawLinkButton>
      </Grid>
    </>
  );
};

export default SubmitSupportTicketForm;
